import React, { Component } from "react";
import {Collapse , Input , Label} from 'reactstrap'
import './SideBar.scss';




class SubDiv extends Component{
    constructor(props) {
        super(props);
   this.state = {
     
        collapse: false ,
        cat: [],
    };
}
    toggle = () => {
        this.setState(state => ({ collapse: !state.collapse }));
      }
      render(){
          return(
             <div className="itemSpan">
                  <div  className="collapse-click"onClick={this.toggle}> {this.props.item}
                  <span className="collapse-icon" style={{ display: `${this.state.collapse ? "none": ""}`}}>+</span>
                  <span className="collapse-icon" style={{ display: `${this.state.collapse ? "": "none"}`}}>-</span>
                  </div>
                    <Collapse isOpen={this.state.collapse}>
                    {this.props.subItem.map(item=>{
                    return (
                        <div className="collapse-item">
                            <span style={{padding: "10px"}}> <Label  className="subItemSpan" check>
                            <Input type="checkbox" value={item} name={this.props.item} onChange={this.props.onChange}/>{' '}{item} 
                            </Label></span>
                        </div>

                    )})}
                        </Collapse>
             </div>
          )
      }
    }
   export default SubDiv